import type { CustomTextColors } from "@gatsby-plugin-generic-page/fragments/customColor"
import type {
  CustomBackgroundColor,
  SquidexMarkdownEmbeddedContent,
} from "~/types/squidex"

export type DataProps = {
  name: string
  content: SquidexMarkdownEmbeddedContent
  textColor: keyof typeof CustomTextColors
  backgroundColor?: CustomBackgroundColor
  backgroundType?: string
  onCloseClick?: () => void
  hasNoCloseButton?: boolean
  image?: {
    src: string
    retinaSrc?: string
  }
  linkData?: {
    title: string
    href?: string
    to?: string
    openInNewTab?: boolean
  }
  modalData?: {
    title: string
    modalText: string
  }
}

export type BaseBarProps = {
  data: DataProps
  type: string
}

export type NotificationBarProps = {
  location: "productPage" | "checkout" | "bonus"
}

export enum BarType {
  INFO = "komunikat",
  PROMOTION = "promocja",
  UNAVAILABLE = "niedostępność",
}
